var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuotationMarkLight = function SvgQuotationMarkLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    "aria-hidden": "true",
    viewBox: "0 0 55 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60816 36.6047V27.1997H15.3577V34.6247C15.3577 38.6447 14.8893 41.5397 13.9523 43.3097C12.6528 45.7397 10.6278 47.5697 7.87753 48.7997L5.88281 45.6047C7.51485 44.9447 8.72377 43.8947 9.50957 42.4547C10.3256 41.0447 10.7789 39.0947 10.8696 36.6047H6.60816ZM20.6618 36.6047V27.1997H29.4114V34.6247C29.4114 38.6447 28.9429 41.5397 28.006 43.3097C26.7064 45.7397 24.6815 47.5697 21.9312 48.7997L19.9365 45.6047C21.5685 44.9447 22.7774 43.8947 23.5632 42.4547C24.3793 41.0447 24.8326 39.0947 24.9233 36.6047H20.6618Z",
    fill: "#FFE575"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuotationMarkLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quotationMarkLight.38097291.svg";
export { ForwardRef as ReactComponent };